/*
 * Rotating number for the urgency pill.
 *
 * Cycles through the merchant's values on an interval, cross-fading each swap.
 * Pauses while the tab is hidden so a shopper coming back doesn't land on a
 * number that jumped several steps mid-blur.
 */
(function () {
  if (window.__vrnUrgencyPills) return;
  window.__vrnUrgencyPills = true;

  if (!window.customElements || window.customElements.get('urgency-rotator')) return;

  window.customElements.define(
    'urgency-rotator',
    class extends HTMLElement {
      connectedCallback() {
        if (this.__init) return;
        this.__init = true;

        this.values = (this.dataset.values || '')
          .split('|')
          .map(function (v) {
            return v.trim();
          })
          .filter(Boolean);

        this.out = this.querySelector('[data-urgency-number]');
        if (!this.out || this.values.length < 2) return;

        var ms = parseInt(this.dataset.interval, 10);
        this.interval = isNaN(ms) || ms < 1000 ? 5000 : ms;

        this.index = this.values.indexOf(this.out.textContent.trim());
        if (this.index < 0) this.index = 0;

        this.reduced =
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onVisibility = this.onVisibility.bind(this);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      onVisibility() {
        if (document.hidden) this.stop();
        else this.start();
      }

      start() {
        if (this.timer) return;
        var self = this;
        this.timer = window.setInterval(function () {
          self.tick();
        }, this.interval);
      }

      stop() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }

      tick() {
        this.index = (this.index + 1) % this.values.length;
        var next = this.values[this.index];

        if (this.reduced) {
          this.out.textContent = next;
          return;
        }

        var out = this.out;
        out.classList.add('is-swapping');
        window.setTimeout(function () {
          out.textContent = next;
          out.classList.remove('is-swapping');
        }, 160);
      }
    }
  );
})();
